export default __webpack_public_path__ + "images/5dc92f9692fdc25034812ebf7fc3a5e6.svg";